export var GameStatus;
(function (GameStatus) {
    /**The game is running*/
    GameStatus["RUNNING"] = "RUNNING";
    /**The game is finished*/
    GameStatus["FINISHED"] = "FINISHED";
    /**The game has been created*/
    GameStatus["CREATED"] = "CREATED";
    /**The game is starting*/
    GameStatus["STARTING"] = "STARTING";
})(GameStatus || (GameStatus = {}));
//# sourceMappingURL=GameTypes.js.map